// extracted by mini-css-extract-plugin
export default {"overlay":"jz-z","bodyOpen":"kz-z","content":"lz-z","header":"mz-z","close":"nz-z","closeNoHeading":"oz-z"};